import { render, staticRenderFns } from "./snUpload.vue?vue&type=template&id=deddc7e6&scoped=true&"
import script from "./snUpload.vue?vue&type=script&lang=js&"
export * from "./snUpload.vue?vue&type=script&lang=js&"
import style0 from "./snUpload.vue?vue&type=style&index=0&lang=less&"
import style1 from "./snUpload.vue?vue&type=style&index=1&id=deddc7e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deddc7e6",
  null
  
)

export default component.exports